import {BankDTO, Completable, pending} from 'kashable-mobile-common';

import {fetchPrimaryBank as fetchPrimaryBankRequest} from '../apis/bank';
import {RootState} from '../store';

import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

const INITIAL_STATE: Completable<BankDTO> = pending();

export const fetchPrimaryBank = createAsyncThunk(
    'primaryBank/fetch',
    async (primaryBank, {rejectWithValue}) => {
        const response = await fetchPrimaryBankRequest();

        if (response.error) {
            rejectWithValue(response);
        }

        return response;
    },
);

export const primaryBankSlice = createSlice({
    name: 'primaryBank',
    initialState: INITIAL_STATE,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearPrimaryBank: () => {
            return {...INITIAL_STATE};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPrimaryBank.pending, () => {
                return pending();
            })
            .addCase(fetchPrimaryBank.fulfilled, (state, action) => {
                return action.payload;
            });
    },
});

export const {
    clearPrimaryBank
} = primaryBankSlice.actions;

export const selectPrimaryBank = (state: RootState) => state.primaryBank;
export default primaryBankSlice.reducer;
